<img *ngIf="media.storage !== 'ext'" [src]="stockageUrl + media.url + '?size=' + (size || 1024)" />
<img *ngIf="media.storage === 'ext'" [src]="media.url + '?size=' + (size || 1024)" />
